import { DELETE, GET, POST, PUT } from "../../../services/api";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";
import { clientTypes } from "../../type/clientTypes";
import { toast } from "react-toastify";
import { cleanObject } from "../../../utils/commonFunctions";

export const addUser = (values, callback) => {
  return async () => {
    try {
      const res = await POST(`${ApiUrl.CLIENT_TENANT_POST}`, values);
    
      if (res?.data?.code === 201) {
        toast.success(res?.data?.message);
        callback();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getUserData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_USER_DATA_PENDING,
        isLoading: true,
      });
      const cleanedPayload = cleanObject(payload);
      const res = await GET(`${ApiUrl.CLIENT_USER_DATA_GET}`, cleanedPayload);
      dispatch({
        type: clientTypes.GET_USER_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_USER_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};

export const getUserActivityData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_USER_ACTIVITY_DATA_PENDING,
        isLoading: true,
      });
      const cleanedPayload = cleanObject(payload);
      const res = await GET(
        `${ApiUrl.CLIENT_USER_ACTIVITY_DATA_GET}`,
        cleanedPayload
      );
      dispatch({
        type: clientTypes.GET_USER_ACTIVITY_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_USER_ACTIVITY_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};

export const getUserDetailsData = (index) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_USER_DETAIL_DATA_PENDING,
        isLoading: true,
      });
      const id = `user_id=${index}`;  
      const res = await GET(`${ApiUrl.CLIENT_USER_DETAILS_DATA_GET}/?${id}`);
      dispatch({
        type: clientTypes.GET_USER_DETAIL_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_USER_DETAIL_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};

export const deleteUser = (urlId, callback) => {
  return async (dispatch) => {
    try {
      const res = await DELETE(`${urlId?.url}/?${urlId?.id}`);
      if (res?.data?.code === 200) {
        toast.success(res?.data?.message);
        callback(res);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error(error);
    }
  };
};

export const updateUser = (_id, values, callback) => {
  return async () => {
    const id = `user_id=${_id}`;
    const res = await PUT(`${ApiUrl.CLIENT_USER_DATA_GET}/?${id}`, values);
    if (res?.data?.code === 200) {
      toast.success(res?.data?.message);
      callback(res);
    } else {
      toast.error(res?.data?.message);
    }
  };
};
export const updateStatus = (urlId, callback) => {
  return async (dispatch) => {
    try {
      const res = await PUT(`${urlId?.url}/?${urlId?.id}`, urlId?.status);
      if (res?.data?.code === 200) {
        toast.success(res?.data?.message);
        callback(res);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error(error);
    }
  };
};

export const bulkUploadAction = (file, callback) => {
  return async () => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await POST(`${ApiUrl.CLIENT_TENANT_BULK_UPLOAD}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res?.data?.code === 201) {
        toast.success(res?.data?.message);
        callback?.();
      } else {
        toast.error(res?.data?.message || "Upload failed");
      }
    } catch (error) {
      toast.error("Something went wrong during upload");
    }
  };
};
export const getTenantUserActivity = (index) => {
  console.log(index, "dsnkkjdhsfd")
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_USER_ACTIVITY_PENDING,
        isLoading: true,
      });
      const id = `user_id=${index?.id}&page=${index?.page}&size=${index?.size}`;

      const res = await GET(`${ApiUrl.CLIENT_USER_ACTIVITY_GET}/?${id}`);
      dispatch({
        type: clientTypes.GET_USER_ACTIVITY_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_USER_ACTIVITY_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};

export const getUserAllocatedCategory = (params) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_USER_CATEGORY_PENDING,
        isLoading: true,
      });

      const res = await GET(`${ApiUrl.CLIENT_USER_CATEGORY_GET}`, params);
      dispatch({
        type: clientTypes.GET_USER_CATEGORY_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_USER_CATEGORY_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};
